"use client";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { WE_ACCEPT_CLASSES } from "./constants";

export const WeAcceptContainer = styled(Container)(({ theme }) => {
  const { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } = getFormatMedia(theme);

  return {
    display: "flex",

    [`& .${WE_ACCEPT_CLASSES.title}`]: {
      marginBottom: theme.spacing(2),
      ...theme.typography.h5,
      [BREAKPOINT_TABLET]: {
        marginBottom: theme.spacing(4),
        ...theme.typography.h4,
      },
    },

    [`& .${WE_ACCEPT_CLASSES.paymentMethods}`]: {
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(2),
      marginBottom: theme.spacing(7),
      [BREAKPOINT_DESKTOP]: { marginBottom: theme.spacing(8) },
    },

    [`& .${WE_ACCEPT_CLASSES.hideOnMobile}`]: {
      display: "none",
      [BREAKPOINT_TABLET]: {
        display: "flex",
      },
    },
  };
});
